<template>
  <div>
    <!-- 池成员 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">成员信息</span>
      </div>
      <el-form :model="queryParams" :inline="true" label-width="68px">
        <el-form-item  prop="iccid">
          <el-input v-model="queryParams.iccid" clearable placeholder="ICCID" @keyup.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item prop="showStatus">
          <el-select v-model="queryParams.showStatus" multiple filterable placeholder="状态" @change="search" clearable>
            <el-option
              v-for="item in state"
              :key="item.cardStatus"
              :label="item.operationName"
              :value="item.cardStatus"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="selectTime" v-if="adminShow">
          <el-select v-model="queryParams.selectTime" filterable placeholder="时间查询方式" @change="search" clearable >
            <el-option label="激活时间" value="active_time"></el-option>
            <el-option label="计划激活时间" value="plan_active_time" ></el-option>
            <el-option label="过期时间" value="card_expire_time" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  prop="dateRange" v-if="adminShow">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="dateRange"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button  icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-download" @click="down" v-hasPermi="['pondManage:pondDetails:down']">下载</el-button>
          <el-button type="primary" icon="el-icon-money" v-if="status == '1'" @click="handlePoolRenewal" v-hasPermi="['pondManage:renewal']">池续约</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="poolCardData" ref="poolCardData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}"  
      @sort-change="tableSortChange" 
      @cell-click="cellClick" 
      @selection-change="handleSelectionChange"
      :row-class-name="tableRowClassName" >
        <el-table-column v-if="adminShow" type="selection" width="55" :selectable="tableColumnSelect"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center" width="200px" show-overflow-tooltip>
          <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="getMonthConsumption(scope.row.iccid)">{{ scope.row.iccid }}</el-link>
              <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                  <i style="font-size:16px;margin-left:2px" class="el-icon-document-copy" @click="copy(scope.row.iccid)"></i>
              </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="msisdn" label="MSISDN" align="center" width="140px">
          <template slot-scope="scope">
            <!-- 流量池用户不可点击 -->
            <el-link v-if="adminShow" type="primary" :underline="false" @click="handleDetail(scope.row.iccid)">{{ scope.row.msisdn }}</el-link>
            <el-link v-else :underline="false">{{ scope.row.msisdn }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="operationName" label="运营商" align="center"></el-table-column>
        <el-table-column prop="planActiveTime" label="计划激活时间" width="140" align="center" sortable="custom"  v-if="adminShow"></el-table-column>
        <el-table-column prop="activeTime" label="激活时间" align="center" width="100" sortable="custom" :formatter="dataFormat"></el-table-column>
        <el-table-column prop="cardExpireTime" label="到期时间" align="center" width="140" sortable="custom" :formatter="dataFormat"></el-table-column>
        <el-table-column prop="showStatus" label="状态" align="center"></el-table-column>
        <el-table-column prop="useFlow" label="本月池用量" align="center" width="130" sortable="custom"></el-table-column>
        <el-table-column prop="singleFlowLimit" label="本月卡峰值" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" width="150" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.index === tabClickIndex"  ref="editInput" v-model="scope.row.remark" v-focus
                        size="small" type="text" @blur="inputBlur(scope.row)" placeholder="请输入备注"/>
            <span v-else>
                <span v-if="scope.row.remark==null || scope.row.remark==''">
                  <i class="el-icon-edit"></i>
                </span>
                <span v-else>{{scope.row.remark}}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="130" fixed="right" v-if="adminShow">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.showStatus == '已激活'"  type="primary" plain  @click="stopCard(scope.row)" v-hasPermi="['card:info:openStopShowStatus']">停机</el-button>
            <el-button size="mini" v-if="scope.row.showStatus == '已停机' || scope.row.showStatus == '待激活'" type="primary" plain  @click="openCard(scope.row)" v-hasPermi="['card:info:openStopShowStatus']">开机</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initPoolCardData"
      />
    </el-card>
    <!--卡流量弹窗-->
    <el-dialog width="600px" title="月流量" :visible.sync="showMonthFlow" @close="memberDialogClose" destroy-on-close v-dialogDrag :modal-append-to-body="false" :close-on-click-modal="false">
        <el-select v-if="!adminShow"  v-model="cardMonthFlowParams.month" placeholder="请选择月份" @change="changeMonthFlow" clearable>
            <el-option
                v-for="item in monthFlowDateList"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
        </el-select>
        <el-table :data="monthFlowData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
          <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
          <el-table-column prop="month" label="月份" align="center"></el-table-column>
          <el-table-column prop="monthFlow" label="月套餐使用量(M)" align="center"></el-table-column>
        </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  cardMonthFlow,
  poolGetFlowPoolCardList,
  poolCardRemark,
  poolGetFlowPoolCardListExport,
  changePoolCardStatus
} from "@/api/api.js";
export default {
  name:'packagePondDetail',
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted(el) {
        el.querySelector('input').focus()
      }
    }
  },
  props: {
    poolId: {
      type: String
    },
    userId:{
      type: String
    },
    status:{
      type: String
    }
  },
  data() {
    return{
      month:undefined,
      queryParams:{
        showStatus:[]
      },
      poolCardData:[],
      total:0,
      page:1,
      pageSize:20,
      state: [
        {
          cardStatus: "2",
          operationName: "待激活"
        },
        {
          cardStatus: "4",
          operationName: "已激活"
        },
        {
          cardStatus: "5",
          operationName: "已停机"
        },
        {
          cardStatus: "6",
          operationName: "预销户"
        },
        {
          cardStatus: "7",
          operationName: "已销户"
        },
      ],
      sortOrder:'',
      sortName:'',
      dateRange:[],
      tabClickIndex: null, // 列表当前点击行的index
      showMonthFlow:false,
      monthFlowData:[],
      monthFlowDateList:[],
      cardMonthFlowParams:{
        month:undefined,
        iccid:undefined
      },
      selectCardList:[]
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
  },
  methods: {
    // 失去焦点初始化
    cellClick(row, column, cell, event) {
      if (column.label === '备注') {
        this.tabClickIndex = row.index
      } else {
        this.tabClickIndex = null
      }
    },
    //判断是否可以被选中
    tableColumnSelect(row,index){
      return row.status !='0' && row.status !='1';
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    inputBlur(row) {
      this.tabClickIndex = null;
      // 保存备注
      let params = {
        id:row.flowPoolCardId,
        remark:row.remark == null ? "":row.remark
      }
      poolCardRemark(params).then(res=>{
        this.$message.success(res.data.message);
      })
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == "planActiveTime"){
        this.sortName = "plan_active_time"
      }else if(val.prop == "activeTime"){
        this.sortName = "active_time"
      }else if(val.prop == "useFlow"){
        this.sortName = "month_flow"
      }else if(val.prop == "cardExpireTime"){
        this.sortName = "card_expire_time"
      }
      this.initPoolCardData();
    },
    dataFormat(row, column, value){
      return value == null ? '-' : value
    },
    handlePoolRenewal(){
      let iccids = this.selectCardList;
      this.$store.dispatch('ClearPoolIccids')
      if(iccids.length > 0){
        this.$store.dispatch('CachePoolIccids', iccids.join(","))
      }
      this.$router.push({name:"pondRenewal",params: { poolId: this.poolId , userId:this.userId }});
    },
    // 池成员
    initPoolCardData(){
      let params = {
        model:{
          order: this.sortOrder,
          sort: this.sortName,
          poolId:this.poolId,
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      poolGetFlowPoolCardList(params).then(res=>{
        this.poolCardData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search(){
      this.page = 1;
      this.initPoolCardData()
    },
    // 重置
    resetQuery(){
      this.queryParams = {};
      this.dateRange = []
      this.sortName = ''
      this.sortOrder = ''
      this.$refs.poolCardData.clearSort();
      this.search();
    },
    // 下载
    down(){
      let params = {
        poolId:this.poolId,
      }
      poolGetFlowPoolCardListExport(params).then(res=>{
        this.$notify({
            title: "成功",
            message: "成员列表导出成功，请在任务中心查看",
            type: "success",
            offset:30
        });
      })
    },
    // 停机操作
    stopCard(row){
      let params = {
        iccid:row.iccid,
        status:"5"
      }
      this.$confirm("此操作将会让该卡停机, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        changePoolCardStatus(params).then(res=>{
          this.$notify({
            title: '成功',
            message: '停机成功',
            type: 'success'
          });
          this.search()
        })
      })
    },
    //开机操作
    openCard(row){
      let params = {
        iccid:row.iccid,
        status:'4'
      }
      this.$confirm("此操作将会让该卡开机, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        changePoolCardStatus(params).then(res=>{
          this.$notify({
            title: '成功',
            message: '开机成功',
            type: 'success'
          });
          this.search()
        })
      })
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },
    /**
     * 卡详情
     */
    handleDetail(iccid) {
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    // 查看月流量
    getMonthConsumption(iccid){
      this.cardMonthFlowParams.iccid = iccid
      cardMonthFlow(this.cardMonthFlowParams).then(res=>{
          this.monthFlowData = res.data.data.historyMonth;
          this.monthFlowDateList = res.data.data.dateList;
          this.showMonthFlow = true;
      })
    },
    memberDialogClose(){
      this.showMonthFlow = false
      this.cardMonthFlowParams = {}
      this.monthFlowData = [];
    },
    changeMonthFlow(month){
      this.cardMonthFlowParams.month = month
      this.getMonthConsumption(this.cardMonthFlowParams.iccid);
    },
    //选中卡号
    handleSelectionChange(element){
      this.selectCardList = element.map(item=>item.iccid);
    }
  },
  created() {
    this.initPoolCardData();
  },
};
</script>
<style scoped lang="less">
.box-card{
  margin-bottom: 4px;
}
</style>


